import CheckItem from "./CheckItem";
import Field from "./Field";

const MOVES = [
  "Pause before responding",
  "Document what happened",
  "Ask one clear question",
  "Stop explaining the same thing again",
  "Set a boundary",
  "Make a practical plan",
  "Get outside support",
  "Say less and watch more",
  "Leave it alone for 24 hours",
  "Admit what I already know",
];

export default function NextMoveStep({ state, update }) {
  const toggle = (item) => {
    const on = state.s5_moves.includes(item);
    update({
      s5_moves: on ? state.s5_moves.filter((x) => x !== item) : [...state.s5_moves, item],
    });
  };

  return (
    <>
      <div>
        <p className="text-[17px] leading-[1.6] text-[color:var(--ks-ink-soft)] mb-5">
          Tap the moves that feel true. Then name the one you're actually making.
        </p>
        <div className="space-y-3">
          {MOVES.map((m) => (
            <CheckItem
              key={m}
              checked={state.s5_moves.includes(m)}
              label={m}
              onToggle={() => toggle(m)}
              testId={`move-${slug(m)}`}
            />
          ))}
        </div>
      </div>

      <Field
        label="My next move is:"
        value={state.s5_nextMove}
        onChange={(v) => update({ s5_nextMove: v })}
        testId="field-s5-next"
        placeholder="One sentence. Specific. Today, not someday."
        rows={3}
      />
      <Field
        label="What I will not do right now:"
        value={state.s5_willNotDo}
        onChange={(v) => update({ s5_willNotDo: v })}
        testId="field-s5-wont"
        placeholder="The thing you keep almost doing."
        rows={3}
      />
      <Field
        label="What would make this worse?"
        value={state.s5_worse}
        onChange={(v) => update({ s5_worse: v })}
        testId="field-s5-worse"
        placeholder="Say it out loud so you don't do it."
        rows={3}
      />
    </>
  );
}

function slug(s) {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
